export interface RiskMatrixValue {
  likelihood: number;
  severity: number;
  score: number;
}

export interface RiskMatrixDisplayProps {
  value?: RiskMatrixValue | null;
  /** Grid cells need a tighter chip than the record view. */
  dense?: boolean;
}

// The column is jsonb, so an unrated field arrives as null, an absent key, or an object of
// nulls. All three read as empty.
export const isRated = (value?: RiskMatrixValue | null): value is RiskMatrixValue =>
  value != null && value.likelihood != null && value.severity != null && value.score != null;

export interface RiskMatrixGridProps {
  value?: RiskMatrixValue | null;
  /** Omit to render the grid read-only. */
  onSelect?: (likelihood: number, severity: number) => void;
  /** Clicking the rated cell clears the rating. */
  onClear?: () => void;
  /** Cell edge in pixels. */
  cellSize: number;
  /** Names this grid, so a surface rendering two of them can be addressed by side. */
  testId?: string;
}

export interface RiskScoringPanelProps {
  inherent?: RiskMatrixValue | null;
  residual?: RiskMatrixValue | null;
  target?: RiskMatrixValue | null;
  onChangeInherent?: (value: RiskMatrixValue | null) => void;
  onChangeResidual?: (value: RiskMatrixValue | null) => void;
  onChangeTarget?: (value: RiskMatrixValue | null) => void;
}
